import React, { useEffect, useState, useRef } from "react";
import {
  GetPaymentVoucherList,
  PaymentVoucherDelete,
  ApproveAccountsPaymentVoucher,
  ExportPaymentVoucherExcel,
} from "../../../Services/Services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Checkbox,
  Menu,
  Divider,
  Grid,
} from "@mui/material";

import { useMediaQuery, Collapse } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Description as FileIcon,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePaymentPdf } from "./PaymentVoucherPrint";
import { generateNeftChallanPdf } from "./PaymentVoucherPrint2";
import config from "../../../config";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToWords } from "to-words";

const PaymentCash = () => {
  // ===== States =====
  const theme = useTheme();
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [ExcelLoading, isExcelLoading] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [expandedPayment, setExpandedPayment] = useState(null);
  const [PaymentVouchers, setPaymentVouchers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [PaymentToApprove, setPaymentToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const dateInputRef = useRef(null);
  const [loading, setLoading] = useState(false); // For scroll pagination
  const [filterLoading, setFilterLoading] = useState(false);
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [paymentDateMenuAnchor, setPaymentDateMenuAnchor] = useState(null);
  const [paymentDateRange, setPaymentDateRange] = useState({
    from: "",
    to: "",
  });
  const [tempPaymentDateRange, setTempPaymentDateRange] = useState({
    from: "",
    to: "",
  });
  const [filters, setFilters] = useState({
    payment_no: "",
    project_name: "",
    ledger: "",
    date_range: "today",
    payment_mode: "Cash",
    payment_date_from: "",
    payment_date_to: "",
  });

  const handleExportExcel = async () => {
    isExcelLoading(true);

    try {
      const params = { ...filters };
      if (
        filters.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }

      if (filters.payment_date_from && filters.payment_date_to) {
        params.payment_date_from = filters.payment_date_from;
        params.payment_date_to = filters.payment_date_to;
      }

      const blob = await ExportPaymentVoucherExcel(params);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      const currentDate = new Date().toISOString().split("T")[0];
      link.setAttribute(
        "download",
        `Payment_Vouchers_Cash_${currentDate}.xlsx`,
      );

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Excel file exported successfully!");
    } catch (error) {
      console.error("Export error:", error);

      if (error.response?.status === 404) {
        toast.error("No data found to export");
      } else if (error.response?.status === 401) {
        toast.error("Session expired. Please login again.");
      } else {
        toast.error("Failed to export Excel file. Please try again.");
      }
    } finally {
      isExcelLoading(false);
    }
  };

  const navigate = useNavigate();

  // 🆕 Helper function to format date display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // 🆕 Get date range display text
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  // ✅ Updated useEffect
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange, paymentDateRange]); // 🆕 Added customDateRange

  // ✅ Updated fetchVouchers
  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters,
  ) => {
    try {
      if (reset) {
        setFilterLoading(true);
      } else {
        setLoading(true);
      }
      const params = { ...filterValues };

      // Add custom dates if custom range selected
      if (
        filterValues.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }
      if (filterValues.payment_date_from && filterValues.payment_date_to) {
        params.payment_date_from = filterValues.payment_date_from;
        params.payment_date_to = filterValues.payment_date_to;
      }
      console.log("API Params being sent:", params);
      const data = await GetPaymentVoucherList(params, pageNum);

      if (reset || pageNum === 1) {
        setPaymentVouchers(
          Array.isArray(data) ? data.results : data.results || [],
        );
      } else {
        setPaymentVouchers((prev) => [
          ...prev,
          ...(Array.isArray(data) ? data.results : data.results || []),
        ]);
      }

      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
    } catch (error) {
      console.error("Failed to fetch vouchers:", error);
      toast.error("Failed to load vouchers");
    } finally {
      // ✅ Reset the appropriate loading state
      setFilterLoading(false);
      setLoading(false);
    }
  };

  // ✅ Updated fetchMoreData
  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage, false, filters);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Updated handleReset
  const handleReset = () => {
    setFilters({
      payment_no: "",
      project_name: "",
      ledger: "",
      date_range: "today", // 🆕 Reset to today
      // payment_date: "",
      payment_mode: "Cash",
      payment_date_from: "",
      payment_date_to: "",
    });
    setCustomDateRange({ from: "", to: "" }); // 🆕 Reset custom dates
    setSelectingDate(null); // 🆕
    setPaymentVouchers([]);
    setPage(1);
    setHasMore(true);
    setTempCustomDateRange({ from: "", to: "" }); // ✅ Add
    setShowCustomDateInputs(false);
    setPaymentDateRange({ from: "", to: "" });
    setTempPaymentDateRange({ from: "", to: "" });
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleEditClick = async (voucher) => {
    navigate("/dashboard/payment-voucher-cash", {
      state: {
        editMode: true,
        voucherData: voucher,
      },
    });
  };

  const handleDelete = async (voucherId) => {
    try {
      await PaymentVoucherDelete(voucherId);
      await fetchVouchers(1, true, filters);
      toast.success("Payment voucher deleted successfully!");
    } catch (error) {
      console.error("Delete error:", error);
      if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.error) {
          toast.error(errorData.error);
        } else if (typeof errorData === "string") {
          toast.error(errorData);
        } else {
          toast.error("Failed to delete payment voucher");
        }
      } else {
        toast.error("Network error. Please try again.");
      }
    }
  };

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveAccountsPaymentVoucher(
        voucher.payment_voucher_no,
        approvedById,
        voucher.status,
        remarkInput,
      );

      setPaymentVouchers((prev) =>
        prev.map((item) =>
          item.payment_voucher_no == updated.payment_voucher_no
            ? updated
            : item,
        ),
      );

      toast.success("Payment Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Payment Voucher.");
    }
  };

  const userRole = localStorage.getItem("role");

  const toWords = new ToWords({ localeCode: "en-IN" });

  // Handle Apply
  const handleApplyPaymentDateRange = () => {
    setPaymentDateRange(tempPaymentDateRange);
    setFilters((prev) => ({
      ...prev,
      payment_date_from: tempPaymentDateRange.from,
      payment_date_to: tempPaymentDateRange.to,
      date_range: "all",
    }));
    setPaymentDateMenuAnchor(null);
  };

  // Handle Cancel
  const handleCancelPaymentDateRange = () => {
    setTempPaymentDateRange(paymentDateRange);
    setPaymentDateMenuAnchor(null);
  };

  // Handle Clear
  const handleClearPaymentDateRange = () => {
    setPaymentDateRange({ from: "", to: "" });
    setTempPaymentDateRange({ from: "", to: "" });
    setFilters((prev) => ({
      ...prev,
      payment_date_from: "",
      payment_date_to: "",
    }));
    setPaymentDateMenuAnchor(null);
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  function formatDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }
  return (
    <>
      <ToastContainer />

      {/* Filter Section */}
      <Box sx={{ mt: -5, pt: -3, mb: 2, width: "100%" }}>
        <Grid container spacing={2} alignItems="center">
          {/* Date Range Dropdown */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(
                      customDateRange.from,
                    )} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                "& .MuiInputBase-input": {
                  fontSize: "0.8rem",
                  padding: "4px 8px",
                },
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.6rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* Project */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Project"
              name="project_name"
              size="small"
              value={filters.project_name}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* Ledger */}
          <Grid item xs={12} sm={2}>
            <TextField
              label="Ledger"
              name="ledger"
              size="small"
              value={filters.ledger}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              label="Payment Date"
              value={
                paymentDateRange.from && paymentDateRange.to
                  ? `${formatDateDisplay(
                      paymentDateRange.from,
                    )} to ${formatDateDisplay(paymentDateRange.to)}`
                  : paymentDateRange.from
                    ? `From ${formatDateDisplay(paymentDateRange.from)}`
                    : paymentDateRange.to
                      ? `To ${formatDateDisplay(paymentDateRange.to)}`
                      : ""
              }
              placeholder="Select payment Date Range"
              onClick={(e) => {
                setPaymentDateMenuAnchor(e.currentTarget);
                setTempPaymentDateRange(paymentDateRange);
              }}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{
                flex: "1 1 100px",
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.65rem",
                },
                "& .MuiInputBase-input": {
                  cursor: "pointer",
                },
              }}
            />
          </Grid>

          <Menu
            anchorEl={paymentDateMenuAnchor}
            open={Boolean(paymentDateMenuAnchor)}
            onClose={handleCancelPaymentDateRange}
            PaperProps={{
              sx: {
                width: 320,
                p: 0,
              },
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#fafafa",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="subtitle2"
                sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
              >
                Select Payment Date Range
              </Typography>

              {/* From and To Date Inputs */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPaymentDateRange.from}
                  onChange={(e) =>
                    setTempPaymentDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempPaymentDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPaymentDateRange.to}
                  onChange={(e) =>
                    setTempPaymentDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempPaymentDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempPaymentDateRange.from && tempPaymentDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 2,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempPaymentDateRange.from)} to{" "}
                  {formatDateDisplay(tempPaymentDateRange.to)}
                </Typography>
              )}

              {/* Action Buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  onClick={handleClearPaymentDateRange}
                  disabled={!paymentDateRange.from && !paymentDateRange.to}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                  }}
                >
                  Clear
                </Button>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelPaymentDateRange}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleApplyPaymentDateRange}
                    disabled={
                      !tempPaymentDateRange.from || !tempPaymentDateRange.to
                    }
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Box>
          </Menu>

          {/* Reset Button */}
          <Grid item xs={12} sm={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: "30px",
                whiteSpace: "nowrap",
                borderRadius: "0",
                fontSize: "0.7rem",
              }}
              fullWidth
            >
              Reset
            </Button>
          </Grid>

          {/* Add Payment Button */}
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              onClick={() => navigate("/dashboard/payment-voucher-cash")}
              sx={{
                height: 30,
                display: "flex",
                alignItems: "center",
                fontSize: "0.7rem",
                borderRadius: "0",
              }}
              fullWidth
            >
              <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> Payment
            </Button>
          </Grid>
          <Grid item xs={12} sm={1}>
            <Button
              variant="contained"
              color="success"
              onClick={handleExportExcel}
              disabled={ExcelLoading || PaymentVouchers.length === 0}
              fullWidth
              sx={{
                height: 30,
                fontSize: "0.7rem",
                borderRadius: 0,
                whiteSpace: "nowrap",
              }}
            >
              {ExcelLoading ? (
                <CircularProgress size={16} color="inherit" sx={{ mr: 0.5 }} />
              ) : (
                <FileIcon fontSize="small" />
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Date Range Menu - UPDATED */}
      <Menu
        anchorEl={dateMenuAnchor}
        open={Boolean(dateMenuAnchor)}
        onClose={() => {
          setDateMenuAnchor(null);
          setShowCustomDateInputs(false);
          setTempCustomDateRange({ from: "", to: "" });
        }}
        PaperProps={{
          sx: {
            width: 350,
            maxHeight: 500,
            "& .MuiTypography-root": {
              fontSize: "0.7rem",
            },
          },
        }}
      >
        {[
          { key: "today", label: "Today" },
          { key: "yesterday", label: "Yesterday" },
          { key: "this_week", label: "This Week" },
          { key: "previous_week", label: "Previous Week" },
          { key: "this_month", label: "This Month" },
          { key: "current_year", label: "Current Year" },
          { key: "financial_year", label: "Financial Year" },
        ].map((range) => (
          <MenuItem
            key={range.key}
            onClick={() => {
              setFilters((prev) => ({ ...prev, date_range: range.key }));
              setCustomDateRange({ from: "", to: "" });
              setDateMenuAnchor(null);
              setShowCustomDateInputs(false);
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography variant="body2">{range.label}</Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem" }}
              >
                {getDateRangeDisplay(range.key)}
              </Typography>
            </Box>
          </MenuItem>
        ))}

        <Divider />

        {/* ✅ Custom Date Range - Expandable */}
        <MenuItem
          onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
          >
            Custom Date Range
          </Typography>
          {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>

        {/* ✅ Both Date Pickers Together */}
        <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 2,
              py: 2,
              bgcolor: "#f5f5f5",
              borderTop: "1px solid #e0e0e0",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mb: 1, display: "block" }}
            >
              Select Date Range
            </Typography>

            {/* From and To Date Inputs Side by Side */}
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextField
                label="From Date"
                type="date"
                size="small"
                value={tempCustomDateRange.from}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    from: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max:
                    tempCustomDateRange.to ||
                    new Date().toISOString().split("T")[0],
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />

              <TextField
                label="To Date"
                type="date"
                size="small"
                value={tempCustomDateRange.to}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    to: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: tempCustomDateRange.from || undefined,
                  max: new Date().toISOString().split("T")[0],
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />
            </Box>

            {/* Selected Range Preview */}
            {tempCustomDateRange.from && tempCustomDateRange.to && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 1.5,
                  p: 1,
                  bgcolor: "#e8f5e9",
                  borderRadius: 1,
                  textAlign: "center",
                  color: "#2e7d32",
                  fontWeight: 500,
                }}
              >
                📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                {formatDateDisplay(tempCustomDateRange.to)}
              </Typography>
            )}

            {/* Apply and Cancel Buttons */}
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelCustomDateRange}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleApplyCustomDateRange}
                disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Collapse>
      </Menu>
<Box sx={{ position: "relative", flex: 1, minHeight: "400px" }}>
  
  {/* ✅ LOADING OVERLAY - Only shows for filter changes */}
  {filterLoading && (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 1000,
        borderRadius: 1,
      }}
    >
      <CircularProgress size={50} thickness={4} color="primary" />
      <Typography sx={{ mt: 2, color: "#333", fontWeight: 500 }}>
        {filters.date_range === "financial_year"
          ? "Loading Financial Year Data..."
          : filters.date_range === "current_year"
          ? "Loading Current Year Data..."
          : filters.date_range === "this_month"
          ? "Loading This Month Data..."
          : filters.date_range === "this_week"
          ? "Loading This Week Data..."
          : filters.date_range === "previous_week"
          ? "Loading Previous Week Data..."
          : filters.date_range === "custom"
          ? "Loading Custom Date Range..."
          : filters.bill_date_from && filters.bill_date_to
          ? "Loading Bill Date Range..."
          : "Loading Data..."}
      </Typography>
      <Typography sx={{ mt: 0.5, color: "#666", fontSize: "0.8rem" }}>
        Please wait, this may take a moment
      </Typography>
    </Box>
  )}

      {/* InfiniteScroll with Mobile/Desktop Views */}
      <InfiniteScroll
        dataLength={PaymentVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        scrollableTarget={isMobile ? undefined : "scrollableDiv"}
        loader={<h4>Loading...</h4>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW */
          <Box
            sx={{
              bgcolor: "background.paper",
              // maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            {PaymentVouchers.map((voucher, index) => (
              <Box key={voucher.id || index}>
                <Box
                  onClick={() =>
                    setExpandedPayment(
                      expandedPayment === voucher.payment_voucher_no
                        ? null
                        : voucher.payment_voucher_no,
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${
                      voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                    }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.payment_number}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          color: "#1976d2",
                        }}
                      >
                        ₹
                        {Number(voucher.total_amount || 0).toLocaleString(
                          "en-IN",
                        )}
                      </Typography>
                      <Chip
                        label={voucher.payment_mode}
                        color="primary"
                        size="small"
                        sx={{
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedPayment === voucher.payment_voucher_no ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Collapse
                  in={expandedPayment === voucher.payment_voucher_no}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${
                        voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                      }`,
                    }}
                  >
                    {/* Amount Box */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 0.8,
                        mb: 1,
                        p: 1,
                        bgcolor: "#e3f2fd",
                        borderRadius: "4px",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#1976d2",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAID AMOUNT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color: "#1976d2",
                          }}
                        >
                          ₹
                          {Number(voucher.total_amount || 0).toLocaleString(
                            "en-IN",
                          )}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Details Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          LEDGER NAME
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.supplier_name ||
                            voucher.expense_name ||
                            voucher.advanceworker_name ||
                            voucher.imprest_name ||
                            voucher.party_name ||
                            voucher.transporter_name ||
                            "N/A"}
                        </Typography>
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PROJECT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.project_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAYMENT MODE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.payment_mode || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAYMENT DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.payment_date || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatDate(voucher.created_at)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${
                              voucher.status === "Approved"
                                ? "#4caf50"
                                : voucher.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800"
                            }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPaymentToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(voucher);
                          }}
                          disabled={voucher.status === "Approved"}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Edit
                            sx={{
                              fontSize: "1rem",
                              color: "#1976d2",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                            setVoucherToDelete(voucher.payment_voucher_no);
                          }}
                          disabled={voucher.status === "Approved"}
                          sx={{
                            bgcolor: "#ffebee",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffcdd2",
                              transform: "scale(1.05)",
                            },
                            "&:disabled": {
                              bgcolor: "#f5f5f5",
                              opacity: 0.5,
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Delete
                            sx={{
                              fontSize: "1rem",
                              color: "#d32f2f",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePaymentPdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print
                            sx={{
                              fontSize: "1rem",
                              color: "#f57c00",
                              transform: "scale(0.6)",
                            }}
                          />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#c8e6c9",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{
                                  fontSize: "1rem",
                                  color: "#2e7d32",
                                  transform: "scale(0.6)",
                                }}
                              />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e8f5e9",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#c8e6c9",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{
                                  fontSize: "1rem",
                                  color: "#2e7d32",
                                  transform: "scale(0.6)",
                                }}
                              />
                            </IconButton>
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                <Divider />
              </Box>
            ))}

            {/* Mobile Total Summary */}
            <Box
              sx={{
                p: 2,
                bgcolor: "#e3f2fd",
                position: "sticky",
                bottom: 0,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  Total Amount:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  ₹
                  {PaymentVouchers.reduce(
                    (sum, v) => sum + parseFloat(v.total_amount || 0),
                    0,
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW */
          <TableContainer
            component={Paper}
            id="scrollableDiv"
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>

                  <TableCell>Voucher No</TableCell>
                  <TableCell>Payment Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Ledger Name</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Paid Amt</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {PaymentVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            setApproveAnchorEl(e.currentTarget);
                            setPaymentToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 2,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell>{voucher.payment_number}</TableCell>
                    <TableCell>{voucher.payment_date}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {voucher.supplier_name ||
                        voucher.expense_name ||
                        voucher.advanceworker_name ||
                        voucher.imprest_name ||
                        voucher.party_name ||
                        voucher.transporter_name}
                    </TableCell>

                    <TableCell>{voucher.project_name}</TableCell>

                    <TableCell>{voucher.division_name}</TableCell>

                    <TableCell>
                      {Number(voucher.total_amount || 0).toLocaleString(
                        "en-IN",
                      )}
                    </TableCell>

                    <TableCell>{voucher.payment_mode}</TableCell>
                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 2,
                        minWidth: 180,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => handleEditClick(voucher)}
                          disabled={voucher.status === "Approved"}
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        >
                          <Edit transform="scale(0.6)" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color="error"
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setVoucherToDelete(voucher.payment_voucher_no);
                          }}
                          disabled={voucher.status === "Approved"}
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        >
                          <Delete transform="scale(0.6)" />
                        </IconButton>

                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="warning"
                          size="small"
                          onClick={() => generatePaymentPdf(voucher)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>

                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              color="info"
                              size="small"
                            >
                              <Visibility transform="scale(0.6)" />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              color="info"
                              size="small"
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </a>
                        ) : (
                          <span
                            style={{ display: "inline-block", width: 30 }}
                          />
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  sx={{
                    "& td": {
                      backgroundColor: "#E3F2FD !important",
                      color: "#000 !important",
                      fontWeight: "bold !important",
                    },
                  }}
                >
                  <TableCell colSpan={8} align="right">
                    Totals:
                  </TableCell>
                  <TableCell>
                    {PaymentVouchers.reduce(
                      (sum, v) => sum + parseFloat(v.total_amount || 0),
                      0,
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell colSpan={7}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>
      </Box>

      {/* Delete Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setVoucherToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(voucherToDelete);
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setVoucherToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Approve Popover */}
      <Dialog
        open={Boolean(approveAnchorEl)}
        onClose={() => {
          if (openConfirmDialog) return;
          setApproveAnchorEl(null);
          setPaymentToApprove(null);
        }}
        maxWidth={false}
        fullScreen={useMediaQuery(theme.breakpoints.down("sm"))}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: "95%", md: "90%", lg: 1050 },
            maxWidth: { xs: "100%", sm: "95%", md: "90%", lg: 1050 },
            maxHeight: { xs: "100%", sm: "90vh" },
            bgcolor: "#fff",
            borderRadius: { xs: 0, sm: 2 },
            m: { xs: 0, sm: 2 },
          },
        }}
      >
        <DialogContent
          sx={{
            p: { xs: 1, sm: 1.5, md: 2 },
            minWidth: { xs: "auto", sm: 400 },
          }}
        >
          {/* ===== PAYMENT VOUCHER ===== */}
          <Box sx={{ overflowX: "auto" }}>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 0,
                minWidth: { xs: "100%", sm: 400, md: "100%" },
              }}
            >
              <Table
                size="small"
                sx={{
                  bgcolor: "#fff",
                  "& .MuiTableCell-root": {
                    padding: {
                      xs: "8px 10px",
                      sm: "8px 12px",
                      md: "10px 16px",
                    },
                    fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.875rem" },
                  },
                }}
              >
                <TableBody>
                  {/* Header */}
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{
                        fontWeight: "bold",
                        bgcolor: "#d9d8d8ff",
                        fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
                        py: { xs: 1, sm: 1.5 },
                      }}
                    >
                      PAYMENT VOUCHER
                    </TableCell>
                  </TableRow>

                  {/* ===== MOBILE VIEW - Card Style ===== */}
                  <TableRow sx={{ display: { xs: "table-row", sm: "none" } }}>
                    <TableCell colSpan={4} sx={{ p: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          p: 1.5,
                          bgcolor: "#fafafa",
                        }}
                      >
                        {/* Voucher No */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Voucher No.
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#1a237e",
                              fontWeight: 500,
                            }}
                          >
                            {PaymentToApprove?.payment_number || "-"}
                          </Typography>
                        </Box>

                        {/* Division */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Division
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#1a237e",
                              fontWeight: 500,
                            }}
                          >
                            {PaymentToApprove?.division_name || "-"}
                          </Typography>
                        </Box>

                        {/* Created Date */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Created Date
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#1a237e",
                              fontWeight: 500,
                            }}
                          >
                            {formatDate(PaymentToApprove?.created_at) || "-"}
                          </Typography>
                        </Box>

                        {/* Ledger Name */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Ledger Name
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#1a237e",
                              fontWeight: 500,
                              textAlign: "right",
                              maxWidth: "60%",
                              wordBreak: "break-word",
                            }}
                          >
                            {PaymentToApprove?.party_name ||
                              PaymentToApprove?.imprest_name ||
                              PaymentToApprove?.supplier_name ||
                              PaymentToApprove?.account_name ||
                              PaymentToApprove?.expense_name ||
                              PaymentToApprove?.advanceworker_name ||
                              PaymentToApprove?.transporter_name ||
                              "-"}
                          </Typography>
                        </Box>

                        {/* Project */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Project
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#1a237e",
                              fontWeight: 500,
                              textAlign: "right",
                              maxWidth: "60%",
                              wordBreak: "break-word",
                            }}
                          >
                            {PaymentToApprove?.project_name || "-"}
                          </Typography>
                        </Box>

                        {/* Advance Amount */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.75rem",
                              color: "#333",
                            }}
                          >
                            Advance Amount
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.75rem",
                              color: "#2e7d32",
                              fontWeight: 600,
                            }}
                          >
                            ₹ {PaymentToApprove?.total_amount || "0"}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>

                  {/* ===== DESKTOP/TABLET VIEW - Table Style ===== */}
                  <TableRow sx={{ display: { xs: "none", sm: "table-row" } }}>
                    <TableCell sx={{ width: "15%" }}>
                      <b>Voucher No.</b>
                    </TableCell>
                    <TableCell sx={{ width: "35%" }}>
                      {PaymentToApprove?.payment_number}
                    </TableCell>
                    <TableCell sx={{ width: "15%" }}>
                      <b>Division</b>
                    </TableCell>
                    <TableCell sx={{ width: "35%" }}>
                      {PaymentToApprove?.division_name}
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ display: { xs: "none", sm: "table-row" } }}>
                    <TableCell>
                      <b>Created Date</b>
                    </TableCell>
                    <TableCell>
                      {formatDate(PaymentToApprove?.created_at)}
                    </TableCell>
                    <TableCell>
                      <b>Ledger Name</b>
                    </TableCell>
                    <TableCell sx={{ wordBreak: "break-word" }}>
                      {PaymentToApprove?.party_name ||
                        PaymentToApprove?.imprest_name ||
                        PaymentToApprove?.supplier_name ||
                        PaymentToApprove?.account_name ||
                        PaymentToApprove?.expense_name ||
                        PaymentToApprove?.advanceworker_name ||
                        PaymentToApprove?.transporter_name ||
                        "-"}
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ display: { xs: "none", sm: "table-row" } }}>
                    <TableCell>
                      <b>Project</b>
                    </TableCell>
                    <TableCell sx={{ wordBreak: "break-word" }}>
                      {PaymentToApprove?.project_name}
                    </TableCell>
                    <TableCell>
                      <b>Advance Amount</b>
                    </TableCell>
                    <TableCell>₹ {PaymentToApprove?.total_amount}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* ===== AGAINST REFERENCE ===== */}
          {PaymentToApprove?.method_of_payment === "against_reference" && (
            <Box sx={{ overflowX: "auto", mt: { xs: 1.5, sm: 2 } }}>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 0,
                  minWidth: { xs: 400, sm: 500, md: "100%" },
                }}
              >
                <Table
                  size="small"
                  sx={{
                    bgcolor: "#fff",
                    "& .MuiTableCell-root": {
                      padding: {
                        xs: "6px 8px",
                        sm: "8px 12px",
                        md: "10px 16px",
                      },
                      fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.875rem" },
                    },
                  }}
                >
                  <TableBody>
                    {/* Header */}
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          border: "1px solid #000",
                          bgcolor: "#d9d8d8ff",
                          fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                          py: { xs: 1, sm: 1.5 },
                        }}
                      >
                        AGAINST REFERENCE
                      </TableCell>
                    </TableRow>

                    {/* Column Headings */}
                    <TableRow>
                      {[
                        "S.No",
                        "Voucher No",
                        "Total Amt",
                        "Rem Amt",
                        "Total Pay Amt",
                      ].map((head) => (
                        <TableCell
                          key={head}
                          align="center"
                          sx={{
                            fontWeight: "bold",
                            border: "1px solid #000",
                            fontSize: {
                              xs: "0.65rem",
                              sm: "0.75rem",
                              md: "0.875rem",
                            },
                            whiteSpace: "nowrap",
                            p: { xs: "4px 6px", sm: "8px 12px" },
                          }}
                        >
                          {head}
                        </TableCell>
                      ))}
                    </TableRow>

                    {PaymentToApprove?.payment_subvoucher?.length > 0 ? (
                      PaymentToApprove.payment_subvoucher.map((item, index) => (
                        <TableRow key={item.id || index}>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #000" }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #000",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.journal_voucher_no || "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #000" }}
                          >
                            {parseFloat(item.journal_total_amount || 0).toFixed(
                              2,
                            )}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #000" }}
                          >
                            {parseFloat(item.journal_rem_amount || 0).toFixed(
                              2,
                            )}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ border: "1px solid #000" }}
                          >
                            {parseFloat(item.paid_amount || 0).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          align="center"
                          sx={{ border: "1px solid #000", py: 2 }}
                        >
                          No references found
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Total Row */}
                    {PaymentToApprove?.payment_subvoucher?.length > 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          align="right"
                          sx={{ fontWeight: "bold", border: "1px solid #000" }}
                        >
                          Total
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ fontWeight: "bold", border: "1px solid #000" }}
                        >
                          {PaymentToApprove.payment_subvoucher
                            .reduce(
                              (sum, item) =>
                                sum + parseFloat(item.paid_amount || 0),
                              0,
                            )
                            .toFixed(2)}
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Amount in Words */}
                    {PaymentToApprove?.payment_subvoucher?.length > 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          sx={{
                            fontStyle: "italic",
                            border: "1px solid #000",
                            fontSize: {
                              xs: "0.65rem",
                              sm: "0.75rem",
                              md: "0.875rem",
                            },
                            wordBreak: "break-word",
                          }}
                        >
                          (In Words):{" "}
                          {toWords.convert(
                            PaymentToApprove.payment_subvoucher.reduce(
                              (sum, item) =>
                                sum + parseFloat(item.paid_amount || 0),
                              0,
                            ),
                          )}
                        </TableCell>
                      </TableRow>
                    )}

                    {/* Narration & Payment Date */}
                    {PaymentToApprove?.payment_subvoucher?.length > 0 && (
                      <>
                        {/* Desktop View */}
                        <TableRow
                          sx={{ display: { xs: "none", sm: "table-row" } }}
                        >
                          <TableCell
                            colSpan={4}
                            sx={{ border: "1px solid #000" }}
                          >
                            <b>Narration:</b> {PaymentToApprove?.narration}
                          </TableCell>
                          <TableCell sx={{ border: "1px solid #000" }}>
                            <b>Payment Date:</b>{" "}
                            {formatDate(PaymentToApprove?.payment_date)}
                          </TableCell>
                        </TableRow>

                        {/* Mobile View */}
                        <TableRow
                          sx={{ display: { xs: "table-row", sm: "none" } }}
                        >
                          <TableCell
                            colSpan={5}
                            sx={{ border: "1px solid #000" }}
                          >
                            <b>Narration:</b> {PaymentToApprove?.narration}
                          </TableCell>
                        </TableRow>
                        <TableRow
                          sx={{ display: { xs: "table-row", sm: "none" } }}
                        >
                          <TableCell
                            colSpan={5}
                            sx={{ border: "1px solid #000" }}
                          >
                            <b>Payment Date:</b>{" "}
                            {formatDate(PaymentToApprove?.payment_date)}
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* ===== PAYMENT MODE ===== */}
          {PaymentToApprove?.method_of_payment?.toLowerCase() !==
            "against reference" && (
            <Box sx={{ overflowX: "auto", mt: { xs: 1.5, sm: 2 } }}>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 0,
                  minWidth: { xs: "100%", sm: 400, md: "100%" },
                }}
              >
                <Table
                  size="small"
                  sx={{
                    bgcolor: "#fff",
                    "& .MuiTableCell-root": {
                      padding: {
                        xs: "8px 10px",
                        sm: "8px 12px",
                        md: "10px 16px",
                      },
                      fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.875rem" },
                    },
                  }}
                >
                  <TableBody>
                    <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                      <TableCell
                        colSpan={6}
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          fontSize: { xs: "0.85rem", sm: "0.9rem", md: "1rem" },
                          py: { xs: 1, sm: 1.5 },
                        }}
                      >
                        PAYMENT MODE
                      </TableCell>
                    </TableRow>

                    {/* ===== MOBILE VIEW - Card Style ===== */}
                    <TableRow sx={{ display: { xs: "table-row", md: "none" } }}>
                      <TableCell colSpan={6} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            p: 1.5,
                            bgcolor: "#fafafa",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold", fontSize: "0.75rem" }}
                            >
                              Payment Mode
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "0.75rem" }}
                            >
                              {PaymentToApprove?.payment_mode || "-"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold", fontSize: "0.75rem" }}
                            >
                              Payment Date
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "0.75rem" }}
                            >
                              {formatDate(PaymentToApprove?.payment_date) ||
                                "-"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold", fontSize: "0.75rem" }}
                            >
                              Cash Amount
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "0.75rem",
                                color: "#2e7d32",
                                fontWeight: 600,
                              }}
                            >
                              ₹ {PaymentToApprove?.total_amount || "0"}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                fontSize: "0.75rem",
                                mb: 0.5,
                              }}
                            >
                              Narration
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "0.75rem",
                                wordBreak: "break-word",
                              }}
                            >
                              {PaymentToApprove?.narration || "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* ===== DESKTOP VIEW - Table Style ===== */}
                    <TableRow sx={{ display: { xs: "none", md: "table-row" } }}>
                      <TableCell sx={{ width: "15%" }}>
                        <b>Payment Mode</b>
                      </TableCell>
                      <TableCell sx={{ width: "18%" }}>
                        {PaymentToApprove?.payment_mode}
                      </TableCell>
                      <TableCell sx={{ width: "15%" }}>
                        <b>Payment Date</b>
                      </TableCell>
                      <TableCell sx={{ width: "18%" }}>
                        {formatDate(PaymentToApprove?.payment_date)}
                      </TableCell>
                      <TableCell sx={{ width: "15%" }}>
                        <b>Cash Amount</b>
                      </TableCell>
                      <TableCell sx={{ width: "19%" }}>
                        ₹ {PaymentToApprove?.total_amount}
                      </TableCell>
                    </TableRow>

                    <TableRow sx={{ display: { xs: "none", md: "table-row" } }}>
                      <TableCell>
                        <b>Narration</b>
                      </TableCell>
                      <TableCell colSpan={5} sx={{ wordBreak: "break-word" }}>
                        {PaymentToApprove?.narration}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>

        {/* ===== DIALOG ACTIONS - 2x2 Grid on Mobile ===== */}
        <DialogActions
          sx={{
            p: { xs: 1.5, sm: 2 },
            borderTop: "1px solid #e0e0e0",
            bgcolor: "#f5f5f5",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, auto)" },
              gap: { xs: 1, sm: 1 },
              width: { xs: "100%", sm: "auto" },
              ml: { sm: "auto" },
            }}
          >
            <Button
              variant="contained"
              color="success"
              size="small"
              onClick={() => {
                setActionType("Approved");
                setOpenConfirmDialog(true);
              }}
              disabled={PaymentToApprove?.status === "Approved"}
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
                order: 1,
              }}
            >
              Approve
            </Button>

            <Button
              variant="contained"
              size="small"
              onClick={() => {
                setActionType("Rejected");
                setOpenConfirmDialog(true);
              }}
              disabled={PaymentToApprove?.status === "Approved"}
              sx={{
                bgcolor: "orange",
                "&:hover": { bgcolor: "#e69500" },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
                order: 2,
              }}
            >
              Reject
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => handleEditClick(PaymentToApprove)}
              disabled={PaymentToApprove?.status === "Approved"}
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
                order: 3,
              }}
            >
              Edit
            </Button>

            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => {
                setApproveAnchorEl(null);
                setPaymentToApprove(null);
              }}
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
                order: 4,
              }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* ===== CONFIRM DIALOG - Responsive ===== */}
      <Dialog
        open={openConfirmDialog}
        maxWidth="xs"
        fullWidth
        onClose={() => {
          setOpenConfirmDialog(false);
          setRemarkInput("");
          setActionType(null);
        }}
        PaperProps={{
          sx: {
            width: { xs: "95%", sm: "400px" },
            maxWidth: { xs: "95%", sm: "400px" },
            m: { xs: 1, sm: 2 },
            borderRadius: { xs: 1, sm: 2 },
          },
        }}
      >
        <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography
            variant="body2"
            sx={{
              mb: { xs: 1.5, sm: 2 },
              fontSize: { xs: "0.85rem", sm: "0.95rem" },
              fontWeight: 500,
            }}
          >
            Please enter remark before{" "}
            {actionType === "Approved" ? "approving" : "rejecting"}:
          </Typography>

          <TextField
            fullWidth
            size="small"
            multiline
            rows={3}
            value={remarkInput}
            onChange={(e) => setRemarkInput(e.target.value)}
            placeholder="Enter remark"
            sx={{
              "& .MuiInputBase-input": {
                fontSize: { xs: "0.85rem", sm: "0.95rem" },
              },
            }}
          />
        </DialogContent>

        <DialogActions
          sx={{
            p: { xs: 1.5, sm: 2 },
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 1,
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setOpenConfirmDialog(false);
                setRemarkInput("");
                setActionType(null);
              }}
              sx={{
                fontSize: { xs: "0.8rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              size="small"
              color={actionType === "Approved" ? "success" : "error"}
              onClick={() => {
                if (!remarkInput.trim()) {
                  toast.error("Remark is required!");
                  return;
                }

                handleApprove({
                  ...PaymentToApprove,
                  status: actionType,
                  remarks: remarkInput,
                });

                setOpenConfirmDialog(false);
                setApproveAnchorEl(null);
                setPaymentToApprove(null);
                setRemarkInput("");
                setActionType(null);
              }}
              sx={{
                fontSize: { xs: "0.8rem", sm: "0.875rem" },
                py: { xs: 1, sm: 0.5 },
              }}
            >
              Confirm
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PaymentCash;
